// @flow
import * as React from 'react';

export type WithWindowTopIntersectionInjectedProps = {|
  +windowTopIntersection: boolean,
  +forwardedRef: {| current: HTMLElement | null |},
|};

function withWindowTopIntersection<OwnProps>(
  WrappedComponent: React.AbstractComponent<{|
    ...OwnProps,
    ...WithWindowTopIntersectionInjectedProps,
  |}>
): React.AbstractComponent<{| ...OwnProps |}> {
  type State = {| windowTopIntersection: boolean |};

  return class WithWindowTopIntersection extends React.Component<
    {| ...OwnProps |},
    State
  > {
    state = {
      windowTopIntersection: false,
    };

    ref = React.createRef<HTMLElement>();

    handleIntersectionChange = (entries: Array<IntersectionObserverEntry>) =>
      this.setState({ windowTopIntersection: entries[0].isIntersecting });

    observer = new IntersectionObserver(this.handleIntersectionChange, {
      root: null,
      rootMargin: '0px 0px -100% 0px',
      threshold: 0,
    });

    componentDidMount() {
      const refCurrent = this.ref.current;
      if (refCurrent !== null && refCurrent instanceof HTMLElement)
        this.observer.observe(refCurrent);
    }

    componentWillUnmount() {
      const refCurrent = this.ref.current;
      if (refCurrent !== null && refCurrent instanceof HTMLElement)
        this.observer.unobserve(refCurrent);
    }

    render() {
      return (
        <WrappedComponent
          forwardedRef={this.ref}
          windowTopIntersection={this.state.windowTopIntersection}
          {...this.props}
        />
      );
    }
  };
}

export default withWindowTopIntersection;
